import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { api__sendOtp } from "@/apis/customer/sendOtp";
import { api__verifyOtp } from "@/apis/customer/verifyOtp";
import { useEffect, useState } from "react";
import OtpLimitExceeded from "@/_MiniApps/auth/ui/OTP/OtpLimitExceeded/OtpLimitExceeded";
import VerifyOtp from "@/_MiniApps/auth/ui/OTP/VerifyOtp";
import { useTranslation } from "@i18n";
import { ValidationException } from "@/common/exceptions/ValidationException";
import Loader from "@componentsShared/Loader/Loader";
import { useAuthActions, useSession } from "@/_MiniApps/auth/AuthContext";
import useHelpers from "@hooks/useHelpers";
import { useCart } from "@/common/Contexts/CartContext";
var DEFAULT_DESIGN = function DEFAULT_DESIGN(t) {
  return {
    label: t("enter_verification_code_continue", {
      ns: "web_auth"
    }),
    btnText: t("mobile_number_confirmation", {
      ns: "web_auth"
    }),
    title: "",
    editNumberClass: "",
    subClassName: "",
    otpBtn: "",
    className: "",
    withborder: true
  };
};
var OtpVerification = function OtpVerification(_ref) {
  var source = _ref.source,
    _ref$forceSend = _ref.forceSend,
    forceSend = _ref$forceSend === void 0 ? false : _ref$forceSend,
    _ref$design = _ref.design,
    design = _ref$design === void 0 ? {} : _ref$design,
    _ref$otp_length = _ref.otp_length,
    otp_length = _ref$otp_length === void 0 ? 6 : _ref$otp_length,
    after_verify_callback = _ref.after_verify_callback,
    scenario = _ref.scenario,
    _ref$phone_number = _ref.phone_number,
    phone_number = _ref$phone_number === void 0 ? "" : _ref$phone_number,
    onEditNumber = _ref.onEditNumber,
    _ref$FIX_ME__extra_pa = _ref.FIX_ME__extra_params,
    FIX_ME__extra_params = _ref$FIX_ME__extra_pa === void 0 ? {} : _ref$FIX_ME__extra_pa,
    LoaderComponent = _ref.LoaderComponent;
  var _useTranslation = useTranslation(["web_common"]),
    t = _useTranslation.t;
  var _useAuthActions = useAuthActions(),
    setUserData = _useAuthActions.setUserData;
  design = _objectSpread(_objectSpread({}, DEFAULT_DESIGN(t)), design);
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn,
    userData = _useSession.user;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useCart = useCart(),
    seedCartMeta = _useCart.seedCartMeta;
  var _useState = useState(false),
    isOtpLimitExceeded = _useState[0],
    setIsOtpLimitExceeded = _useState[1];
  var _useState2 = useState(false),
    isOtpSent = _useState2[0],
    setIsOtpSent = _useState2[1];
  var _useState3 = useState(false),
    loading = _useState3[0],
    setLoading = _useState3[1];
  var _useState4 = useState(false),
    pageReady = _useState4[0],
    setPageReady = _useState4[1];
  var _useState5 = useState(""),
    otp = _useState5[0],
    setOtp = _useState5[1];
  var _useState6 = useState(null),
    validationException = _useState6[0],
    setValidationException = _useState6[1];
  var afterVerify = function afterVerify(userData) {
    var cart = userData.product_coupon_cart;
    if (cart !== null && cart !== void 0 && cart.cart_id && typeof window !== "undefined") {
      document.cookie = "cart_id=".concat(cart.cart_id, "; path=/; max-age=2592000; SameSite=Lax");
      seedCartMeta(cart.cart_id, cart.count);
    }
    setUserData(userData);
    after_verify_callback(userData);
  };
  useEffect(function () {
    if (!isLoggedIn || forceSend) {
      sendOtpToPhoneNumber(phone_number, source);
    } else {
      afterVerify(userData);
    }
  }, []);
  useEffect(function () {
    // apply auto submit
    if (otp.length === otp_length) {
      onSubmitOtp();
    }
  }, [otp]);
  var handle__resend__sendOtp = function handle__resend__sendOtp() {
    setIsOtpSent(true);
    setOtp("");
    sendOtpToPhoneNumber(phone_number, source);
  };
  var sendOtpToPhoneNumber = function sendOtpToPhoneNumber(phone_number, source) {
    setLoading(true);
    setValidationException(null);
    api__sendOtp({
      phone_number: phone_number,
      otp_length: otp_length,
      source: source
    }).then(function () {
      setPageReady(true);
    })["catch"](function (error) {
      if (error instanceof ValidationException) {
        var exp = error;
        if (exp.isError("blocked")) {
          setIsOtpLimitExceeded(true);
          setPageReady(true);
          return;
        }
        throw error;
      }
    })["finally"](function () {
      setLoading(false);
    });
  };
  var onSubmitOtp = function onSubmitOtp() {
    var _document$cookie$spli;
    setLoading(true);
    setValidationException(null);
    var cartId = typeof window !== "undefined" ? ((_document$cookie$spli = document.cookie.split(";").map(function (c) {
      return c.trim();
    }).find(function (c) {
      return c.startsWith("cart_id=");
    })) === null || _document$cookie$spli === void 0 ? void 0 : _document$cookie$spli.slice("cart_id=".length)) || undefined : undefined;
    api__verifyOtp(_objectSpread({
      phone_number: phone_number,
      otp: Number(otp),
      source: source,
      scenario_text: scenario,
      cart_id: cartId
    }, FIX_ME__extra_params)).then(function (userData) {
      afterVerify(userData);
    })["catch"](function (err) {
      if (err instanceof ValidationException) {
        setValidationException(err);
        return;
      }
      throw err;
    })["finally"](function () {
      setIsOtpSent(false);
      setLoading(false);
    });
  };
  if (!pageReady) return /*#__PURE__*/React.createElement("div", {
    className: "min-h-[500px] flex justify-center items-center"
  }, LoaderComponent || /*#__PURE__*/React.createElement(Loader, {
    smallLoader: true
  }));
  if (isLoggedIn && forceSend === false) return /*#__PURE__*/React.createElement("div", null, LoaderComponent || /*#__PURE__*/React.createElement(Loader, {
    smallLoader: true
  }));
  if (isOtpLimitExceeded) return /*#__PURE__*/React.createElement(OtpLimitExceeded, {
    onClick: function onClick() {
      return navigateTo("/", {
        ref: 'otp_limit_exceeded',
        source: source
      });
    },
    className: design.className ? design.className : ""
  });
  return /*#__PURE__*/React.createElement(VerifyOtp, {
    value: otp,
    phoneNumber: phone_number,
    loading: loading,
    subClassName: design.subClassName,
    title: design.title,
    label: design.label,
    className: design.className,
    btnText: design.btnText,
    otpBtn: design.otpBtn,
    length: otp_length,
    error: validationException === null || validationException === void 0 ? void 0 : validationException.extractErrorMessageFrom(["otp", "blocked"]),
    isOtpSent: isOtpSent,
    onChange: setOtp,
    onValidate: onSubmitOtp,
    onEdit: onEditNumber,
    onResend: handle__resend__sendOtp,
    setIsOtpSent: setIsOtpSent,
    editNumberClass: design.editNumberClass,
    withborder: design.withborder,
    countDownfromArib: undefined
  });
};
export default OtpVerification;